import { render, staticRenderFns } from "./Compensation.vue?vue&type=template&id=5314bdb2&scoped=true"
import script from "./Compensation.vue?vue&type=script&lang=js"
export * from "./Compensation.vue?vue&type=script&lang=js"
import style0 from "./Compensation.vue?vue&type=style&index=0&id=5314bdb2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5314bdb2",
  null
  
)

export default component.exports